export const roomsData = [
    {
        slug: "deluxe-room",
        roomsImage: "/images/rooms/deluxe/Deluxe_Room_Limited_View.webp",
        roomName: "Deluxe Room Limited View",
        banner: "/images/deluxe-banner.png",
        metaTitle: "Book Deluxe Hotel Room in Shimla|The Twin Towers Hotel in Kufri, Shimla",
        metaDesc: "These are one of the best deluxe rooms in Kufri. There is high-speed Internet access (Wi-Fi), an LED TV, an electric kettle, an ironing board, and more.",
        shortDesc: "These spacious rooms (380 square feet) are equipped with all the latest conveniences and amenities for a relaxing and luxurious stay.",
        roomDesc: "Our spacious luxury rooms in Kufri, spanning 380 square feet, offer a perfect blend of comfort and elegance. As a 4-star hotel in Kufri, we provide world-class amenities, ensuring a relaxing stay. Each room features high-speed Internet access (Wi-Fi), an LED TV, an electric kettle, an ironing board, a wardrobe, a daily cleaning service, and a hairdryer. If you are looking for the best deluxe room in Kufri, our hotel is the perfect choice. Experience the finest hospitality at the best hotel in Kufri, where luxury and comfort meet to create an unforgettable experience.",
        roomsPrice: "6,000/night",
        gallery: {
            imageone: "/images/rooms/deluxe/Deluxe_Room_Limited_View.webp",
            imagetwo: "/images/rooms/deluxe/Deluxe_Wooden_Bedroom_Suite.webp",
            imagethree: "/images/rooms/deluxe/Deluxe_Room_Limited_View (2).webp",
            imagefour: "/images/rooms/deluxe/Deluxe_Room_Workspace_Area.webp",
            imagefive: "/images/rooms/deluxe/Deluxe_Room_In_Room_Breakfast.webp",
        },
        amenities: [
            {
                title: "Tea & Coffee Maker",
                icon: "/icons/coffee-maker.svg"
            },
            {
                title: "LED TV",
                icon: "/icons/tv.svg"
            },
            {
                title: "Electric Safe",
                icon: "/icons/electric-safe.svg"
            },
            {
                title: "Free Wi-Fi",
                icon: "/icons/wifi.svg"
            },
            {
                title: "360 Sq Ft",
                icon: "/icons/area.svg"
            },
            {
                title: "Luxury Toiletries",
                icon: "/icons/luxury-toiletries.svg"
            },
        ],
        area: "360 Sq Ft",
        beds: "(3) bed's",
        guests: "(4) Guest's",
        SingleRoomSchema: "DeluxeRoomSchema"
    },
    {
        slug: "premier-room",
        roomsImage: "/images/premium-room.webp",
        roomName: "Premier Valley View Rooms",
        banner: "/images/premier-banner.png",
        metaTitle: "Book Luxury Premium Hotel Room in Shimla-The Twin Towers Hotel in Shimla",
        metaDesc: "These best premier rooms in Kufri, shimla are spacious measuring in at 380 square feet. They come with a king-sized bed and breath-taking views of the surrounding valley.",
        shortDesc: "These best premier rooms in Kufri are spacious measuring in at 380 square feet. They come with a king-sized bed and breath.",
        roomDesc: "The Twin Towers Hotel in Shimla offers the best premier rooms in Kufri, designed for comfort and luxury. These spacious rooms measure 380 square feet and feature a king-sized bed with breathtaking views of the surrounding valley. As the best hotel in Kufri, it provides top-notch amenities, including a stylish desk, an electric safe, free Wi-Fi, a cozy sitting area, and elegant hardwood flooring. The best room in Kufri also includes a spacious closet and ample storage. Whether visiting Shimla for leisure or business, these rooms ensure a relaxing and memorable stay. Experience unmatched hospitality and luxury in Kufri!",
        roomsPrice: "6,000/night",
        gallery: {
            imageone: "/images/rooms/premier/Premier_Valley_View_Rooms.webp",
            imagetwo: "/images/rooms/premier/Premier_Valley_View_Rooms (2).webp",
            imagethree: "/images/rooms/premier/Premier_Valley_View_Rooms (3).webp",
            imagefour: "/images/rooms/premier/Premier_Valley_View_Rooms (4).webp",
            imagefive: "/images/rooms/premier/Luxury_Hotel_Breakfast_with_Valley_View.webp",

        },
        amenities: [
            {
                title: "Tea & Coffee Maker",
                icon: "/icons/coffee-maker.svg"
            },
            {
                title: "LED TV",
                icon: "/icons/tv.svg"
            },
            {
                title: "Electric Safe",
                icon: "/icons/electric-safe.svg"
            },
            {
                title: "Free Wi-Fi",
                icon: "/icons/wifi.svg"
            },
            {
                title: "360 Sq Ft",
                icon: "/icons/area.svg"
            },
            {
                title: "Luxury Toiletries",
                icon: "/icons/luxury-toiletries.svg"
            },
        ],
        area: "380 Sq Ft",
        beds: "(3) bed's",
        guests: "(4) Guest's",
        SingleRoomSchema: "PremierRoomSchema"
    },
    {
        slug: "executive-room",
        roomsImage: "/images/executive-room.webp",
        roomName: "Executive Suite Valley View",
        banner: "/images/exec-banner.png",
        metaTitle: "Best Executive Hotel Room in Shimla| The Twin Towers Hotel in Shimla, Kufri",
        metaDesc: "These best executive rooms in Kufri are fully soundproof and include contemporary furnishings. Guests may enjoy modern conveniences including a keyless entry system",
        shortDesc: "These 380-square-feet rooms provide highly customized attention and maximum convenience. These best executive rooms in Kufri are fully soundproof",
        roomDesc: "The Twin Towers Hotel in Shimla, the best hotel in Kufri,  offers luxurious and spacious best executive rooms in Kufri designed for ultimate comfort. These 380-square-feet rooms provide highly customized attention and maximum convenience, ensuring a premium stay. Fully soundproof and equipped with contemporary furnishings, they create a peaceful retreat. Guests can enjoy modern amenities, including a keyless entry system, free Wi-Fi, a smart TV, and a tea and coffee maker. These Kufri rooms with balcony offer stunning views, allowing guests to unwind in nature’s beauty. As some of the best rooms with mountain views in Shimla, they provide breathtaking panoramas of ",
        roomsPrice: "6,000/night",
        gallery: {
            imageone: "/images/rooms/executive/Executive_Suite_Valley_View.webp",
            imagetwo: "/images/rooms/executive/Executive_Suite_Valley_view (1).webp",
            imagethree: "/images/rooms/executive/Executive_Suite_Valley_view (2).webp",
            imagefour: "/images/rooms/executive/Executive_Room_In-Room_Dining.webp",
            imagefive: "/images/rooms/executive/Executive_Suite_Valley_view (4).webp",
        },
        amenities: [
            {
                title: "Tea & Coffee Maker",
                icon: "/icons/coffee-maker.svg"
            },
            {
                title: "LED TV",
                icon: "/icons/tv.svg"
            },
            {
                title: "Electric Safe",
                icon: "/icons/electric-safe.svg"
            },
            {
                title: "Free Wi-Fi",
                icon: "/icons/wifi.svg"
            },
            {
                title: "360 Sq Ft",
                icon: "/icons/area.svg"
            },
            {
                title: "Luxury Toiletries",
                icon: "/icons/luxury-toiletries.svg"
            },
        ],
        area: "80 Sq Mt",
        beds: "(3) bed's",
        guests: "(4) Guest's",
        SingleRoomSchema: "ExecutiveRoomSchema"
    },
    {
        slug: "family-suite-room",
        roomsImage: "/images/family-suite-room.webp",
        roomName: "Family Suite Himalayan View",
        banner: "/images/family-banner.png",
        metaTitle: "Book Family Suite Hotel Room In Shimla | The Twin Towers Hotel in Kufri, Shimla",
        metaDesc: "The special amenities in this room category are here to make your stay more enjoyable and productive making it the best family suite in Kufri",
        shortDesc: "Our 650-square-feet Family Suite has a classic design and a picturesque view of the mountains.",
        roomDesc: "The Family Rooms in Kufri at The Twin Towers Hotel in Shimla offer an unmatched blend of luxury and comfort. Our spacious 650-square-foot Family Suite boasts a classic design with breathtaking rooms with mountain views in Shimla. This 4-star hotel in Kufri ensures top-tier amenities, including a walk-in wardrobe, king-sized beds, a minibar, an electric safe, Wi-Fi, LED televisions, and modern bathrooms with premium toiletries. Enjoy an electronic key entrance for added security. Featuring Kufri rooms with a balcony, this suite guarantees a refreshing and scenic experience, making it the best hotel in Kufri for families seeking a memorable stay.",
        roomsPrice: "6,000/night",
        gallery: {
            imageone: "/images/rooms/family/Family_Suite_Himalayan_View.webp",
            imagetwo: "/images/rooms/family/Family_Suite_Himalayan_View (1).webp",
            imagethree: "/images/rooms/family/Family_Suite_Himalayan_View (3).webp",
            imagefour: "/images/rooms/family/Family_Suite_Room_Himalayan_View.webp",
            imagefive: "/images/rooms/family/Family_Suite_Room.webp",

        },
        amenities: [
            {
                title: "Tea & Coffee Maker",
                icon: "/icons/coffee-maker.svg"
            },
            {
                title: "LED TV",
                icon: "/icons/tv.svg"
            },
            {
                title: "Electric Safe",
                icon: "/icons/electric-safe.svg"
            },
            {
                title: "Free Wi-Fi",
                icon: "/icons/wifi.svg"
            },
            {
                title: "360 Sq Ft",
                icon: "/icons/area.svg"
            },
            {
                title: "Luxury Toiletries",
                icon: "/icons/luxury-toiletries.svg"
            },
        ],
        area: "650 Sq Ft",
        beds: "(3) bed's",
        guests: "(4) Guest's",
        SingleRoomSchema: "FamilyRoomSchema"
    },
]
